import { Component } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-detail-harga',
  templateUrl: './detail-harga.component.html',
  styleUrls: ['./detail-harga.component.css']
})
export class DetailHargaComponent {
  modalId = 'modal-price-detail';
  finalPrice = 0;
  tax = 0;
  startPrice = 0;
  priceAfterTax = 0;
  totalDiscount = 0;
  sealFee = 0;
  priceBeforeTax = 0;

  public show(startPrice: number = 0, totalDiscount: number = 0, listDiscount: any = [], tax: number = 0, finalPrice: number = 0, priceBeforeTax: number = 0, materai: number = 0) {
    this.startPrice = startPrice;
    this.totalDiscount = totalDiscount;
    this.priceBeforeTax = priceBeforeTax;
    this.tax = tax;
    this.priceAfterTax = startPrice - this.totalDiscount + tax;
    if (materai > 0) {
      this.sealFee = materai;
    } else {
      this.sealFee = listDiscount.find(x => x.discountType === 'ZMTR') ? listDiscount.find(x => x.discountType === 'ZMTR').discountValue : 0;
    }
    if (finalPrice === 0) {
      this.finalPrice = this.priceAfterTax + this.sealFee;
    } else {
      this.finalPrice = finalPrice;
    }
    $(`#${this.modalId}`).modal('show');
  }

  hide() {
    $(`#${this.modalId}`).modal('hide');
  }

  onContainerClicked(event: MouseEvent) {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }
}
